import { getAPIURL } from '../../GlobalComponents/URLs'

export interface FetchPostBatchFilePayload {
    dataURI: string
    batchGroupGUID: string
    filename: string
}

export const fetchPostBatchFile = async (payload: FetchPostBatchFilePayload) => {
    let url = getAPIURL() + 'master/PostBatchFile'
    await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
    }).then((resp) => {
        if (!resp.ok) {
            if (resp.status == 413) throw new Error('File too large!')
            else throw new Error(resp.statusText)
        }
    })
}

export interface FetchBatchQueueSubmitPayload {
    ProgDomain: string
    ProgName: string
    Params: string
    Username: string
    Email: string
    Crystal: boolean
}

export const fetchBatchQueueSubmit = async (payload: FetchBatchQueueSubmitPayload) => {
    let url = getAPIURL() + 'master/batchqueue/submit'
    let req = await fetch(url, {
        credentials: 'include',
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
    })
        .then((resp) => {
            if (resp.ok) {
                return resp.json()
            } else throw new Error('bad request ' + resp.statusText)
        })
        .catch((err) => {
            console.error('Error posting vendor inventory batch file: ', err)
        })
    let json: string = await req

    return json
}
